/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import Territories from './../modules/krannich-portal/zip-code-based-territories.json';
export interface IZipCode {
    Locality: string;
    Pcode: number;
    State: string;
    Territory: string;
}
export class GetAddressFromZipCodeInput implements Msdyn365.IActionInput {
    public zipCode: string;
    constructor(zipCode: string) {
        this.zipCode = zipCode;
    }

    public getCacheKey = () => `AddressFromZipCode-${this.zipCode}`;
    public getCacheObjectType = () => 'AddressFromZipCode';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IGetAddressFromZipCodeData {}

async function actionAddressFromZipCode(input: GetAddressFromZipCodeInput, ctx: Msdyn365.IActionContext): Promise<any> {
    const zipCode = input.zipCode;
    if (Territories && Territories.length > 0) {
        const filterObj = Territories.filter((item: any) => item.Pcode === Number(zipCode));
        return { ...filterObj[0] };
    } else {
        return undefined;
    }
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<any>>actionAddressFromZipCode,
    id: 'GetAddressFromZipCode'
});
